import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

export class EditUserForm {
  public username: string = '';
  public email: string = '';
  public password: string = '';
  public passwordConf: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public role: string = '';
  public department: string = '';
  public recreate: boolean = false;
  public unlock: boolean = false;

  public rules: { [key: string]: FormValidationFunction[] } = {
    username: [
      (v: string) => !!v || 'Username is required',
      (v: string) => v.length <= 24 || 'Username can be at most 24 characters',
      (v: string) => v.length >= 5 || 'Username has to be at least 5 characters',
    ],
    email: [
      (v: string) => !!v || 'Email is required',
    ],
    password: [
      ...PasswordValidationCallbacks,
    ],
    role: [
      (v: string) => !!v || 'You have to select a role',
    ],
    department: [
      (v: string) => !!v || 'You have to select a department',
    ],
  };
}
